import { render, staticRenderFns } from "./AppContentQuestionEdit.vue?vue&type=template&id=39c81444&scoped=true&"
import script from "./AppContentQuestionEdit.vue?vue&type=script&lang=js&"
export * from "./AppContentQuestionEdit.vue?vue&type=script&lang=js&"
import style0 from "./AppContentQuestionEdit.vue?vue&type=style&index=0&id=39c81444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c81444",
  null
  
)

export default component.exports